import script from "./BaseSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSelect.vue?vue&type=style&index=0&id=46248c2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46248c2c"]])

export default __exports__